import React, { Component, Suspense } from 'react';
import './App.css';
import './MobileApp.css';
import './imagezoom.css';
import './SmStyle.css';
import './SmGeneral.css';
import './SmOverrideStyle.css';
import theme from './staymenu-theme';
import { Switch, Route, withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { ThemeProvider } from '@material-ui/styles';
import { default as i18n } from './i18n';
import { setAdminLanguage } from './admin/i18n/adminI18n';
import PrivateRoute from './components/PrivateRoute';
import GuestRoute from './components/GuestRoute/GuestRouteComponent';

import { default as AdminLoginPage } from './admin/pages/Login/AdminLogin';
import { default as AdminDashboardPage } from './admin/pages/Dashboard';
// import { default as AdminItemPage } from './admin/pages/Item/AdminItem';
import { default as ChatIntentPage } from './admin/pages/ChatIntent/ChatIntent';
import { default as ImportChatIntentPage } from './admin/pages/ChatIntentImport/chatIntentImport';
import { default as OutOfStockPage } from './admin/pages/OutOfStock/OutOfStockPage';
import { default as BookingPage } from './admin/pages/Booking/BookingMain';
import { default as GuideDocumentPage } from './admin/pages/GuideDocument/GuideDocumentMain';
import { default as HotelFacilityPage } from './admin/pages/HotelFacility/HotelFacilityMain';
import { default as EventHotelPage } from './admin/pages/EventHotel/EventHotelMain';
import { default as SidebarPage } from './admin/pages/Sidebar/SidebarMain';
import { default as SpecialOfferPage } from './admin/pages/SpecialOffer/SpecialOffer';
import { default as RetailOfferPage } from './admin/pages/RetailOffer/RetailOffer';
import AdminHotelDescriptionPage from './admin/pages/HotelDescription/adminHotelDescription';
import { default as GeneralSettingPage } from './admin/pages/GeneralSetting/generalSetting';
import { default as OrderSetupPage } from './admin/pages/OrderSetup/ordersetuppage';
import FnbAdditionalItemPage from './admin/pages/FnbAdditionalItem/FnbAdditionalItem';
import ImportItemLanguagePage from './admin/pages/ImportItemLanguage/importItemLanguage';
import CmsLanguage from './admin/cms/CmsLanguage';
import CmsMenu from './admin/cms/CmsMenu';
import CmsTask from './admin/cms/CmsTask';
import WebSetting from './admin/cms/WebSetting';
import CmsPaymentType from './admin/cms/CmsPaymentType';
import CmsTransportationType from './admin/cms/CmsTransportationType';
import BookingItemPage from './admin/pages/BookingItem/BookingItem';
import BookingSubCategoryPage from './admin/pages/BookingSubCategory/BookingSubCategory';
import BookingCategoryPage from './admin/pages/BookingCategory/BookingCategory';
import BookingTransactionPage from './admin/pages/BookingTransaction/BookingTransaction';
import AuditLogPage from './admin/pages/AuditLog/AuditLog';
import { default as PopupPage } from './admin/pages/Popup/PopupMain';
import { default as TemplatePage } from './admin/pages/Template/TemplateMain';
import CmsLaundryDelivery from './admin/cms/CmsLaundryDelivery';
import CmsLaundryService from './admin/cms/CmsLaundryService';
import OutOfStockRecipientPage from './admin/pages/OutOfStockRecipient/OutOfStockRecipient';
import GuestLoginLogPage from './admin/pages/GuestLoginLog/GuestLoginLog';

import SingleListMain from './modules/SingleList/SingleListMain';
import SingleListConfirm from './modules/SingleList/SingleListConfirm';
import AboutHotelPage from './pages/AboutHotel/aboutHotel';
import AmenityMainPage from './pages/Amenities/amenityMain';
import AmenityConfirmPage from './pages/Amenities/amenityConfim';
import BillingPage from './pages/Billing';
import BookingMainPage from './pages/Booking/bookingMain';
import BookTaxiPage from './pages/BookTaxi/BookTaxi';
import FnbMainPage from './pages/FnB/fnbMain';
import FnbConfirmPage from './pages/FnB/fnbConfirm';
import GuestLoginPage from './pages/GuestLogin/GuestLogin';
import GuestGuideDocumentPage from './pages/GuestGuideDocument/guestGuideDocument';
import HotelEventDetailPage from './pages/HotelEvent/HotelEvent';
import HotelFacilityDetailPage from './pages/HotelFacility/HotelFacility';
import HomeEventAndFacilityAll from './pages/HomeEventAndFacilityAll/HomeEventAndFacilityAll';
import HomeSelectService from './pages/HomeSelectService/HomeSelectService';
import CompendiumDetailPage from './pages/Compendium/Compendium';
import HotelReviewPage from './pages/HotelReview';
import HousekeepingOptInPage from './pages/HousekeepingOptIn/housekeepingOptIn';
import HousekeepingLinenChangePage from './pages/HousekeepingLinenChange/housekeepingLinenChange';
import LaundryMainPage from './pages/Laundry/laundryMain';
import LaundryConfirmPage from './pages/Laundry/laundryConfim';
import MasterHomePage from './pages/Master/masterHome';
import MasterChatPage from './pages/Master/masterChat';
import MasterOrderPage from './pages/Master/masterOrder';
import PrintFilePage from './pages/PrintFile/PrintFile';
import PrintFilePreviewPage from './pages/PrintFilePreview';
import RetailOfferClientPage from './pages/RetailOfferClient/RetailOfferClient';
import ShoppingMainPage from './pages/Shopping/shoppingMain';
import ShoppingConfirmPage from './pages/Shopping/shoppingConfim';
import SpaMainPage from './pages/Spa/spaMain';
import SpaConfirmPage from './pages/Spa/spaConfirm';
import SpecialOfferClientPage from './pages/SpecialOfferClient/SpecialOfferClient';
import TvChannelPage from './pages/TvChannel/TvChannel';
import RcuControlMainPage from './pages/RcuControl/RcuControlMain';
import UploadTestPage from './pages/UploadTest';
import WakeUpCallPage from './pages/WakeUpCall/WakeUpCall';
import PaymentLogPage from './admin/pages/PaymentLog/PaymentLog';
import OrderPayResult from './pages/FnB/OrderPayResult';
// import SimpleLoadingScreen from './components/SimpleLoadingScreen';

const isDisableBot = process.env.REACT_APP_STAYCHAT_BOT_DISABLE !== "false";

@inject('commonStore', 'translationStore', 'chatStore')
@withRouter
@observer
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.commonStore.setHistory(this.props.history);

    const lang = this.props.translationStore.getLanguage();
    if (lang) {
      i18n.changeLanguage(lang);
    }

    // 初始化后台管理语言
    this.initAdminLanguage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.initAdminLanguage();
    }
  }

  initAdminLanguage = () => {
    if (window.location.pathname.startsWith('/admin/')) {
      const pathParts = window.location.pathname.split('/');
      const urlLang = pathParts.find(part => part === 'ar-AE' || part === 'en');

      if (urlLang) {
        setAdminLanguage(urlLang);
      } else {
        const savedLang = window.localStorage.getItem('adminLang');
        if (savedLang && (savedLang === 'ar-AE' || savedLang === 'en')) {
          setAdminLanguage(savedLang);
        } else {
          setAdminLanguage('en');
        }
      }
    }
  }

  render() {
    let isDisableBotButton = isDisableBot || window.location.pathname.includes("login") || window.location.pathname.includes("admin");

    return (
      <ThemeProvider theme={theme}>
        <Suspense fallback={null}>
          <div id="main-wrapper" style={isDisableBotButton ? { overflow: 'auto' } : { overflow: 'hidden' }}>
            <Switch>
              <Route path='/login/:roomNumber?/:lastName?' component={GuestLoginPage} />
              <Route path='/print-preview/:printCode' component={PrintFilePreviewPage} />
              <Route path='/home' component={MasterHomePage} />
              <Route path='/chat' component={MasterChatPage} />
              <Route path='/order' component={MasterOrderPage} />
              <Route path='/single-list/:menuID?/language/:languageID?' component={SingleListMain} />
              <Route path='/single-list-confirm/:menuID?/language/:languageID?/item/:itemID?' component={SingleListConfirm} />
              <Route path='/amenity' component={AmenityMainPage} />
              <Route path='/amenity-confirm' component={AmenityConfirmPage} />
              <Route path='/booking' component={BookingMainPage} />
              <Route path='/wakeup-call' component={WakeUpCallPage} />
              <Route path='/transportation' component={BookTaxiPage} />
              <Route path='/tv-channel' component={TvChannelPage} />
              <Route path='/rcu-control' component={RcuControlMainPage} />
              <Route path='/laundry' component={LaundryMainPage} />
              <Route path='/laundry-confirm' component={LaundryConfirmPage} />
              <Route path='/shopping' component={ShoppingMainPage} />
              <Route path='/shopping-confirm' component={ShoppingConfirmPage} />
              <Route path='/fnb/:taskId?' component={FnbMainPage} />
              <Route path='/fnb-confirm' component={FnbConfirmPage} />
              <Route path='/spa/:taskId?' component={SpaMainPage} />
              <Route path='/spa-confirm' component={SpaConfirmPage} />
              <Route path='/about-hotel' component={AboutHotelPage} />
              <Route path='/billing' component={BillingPage} />
              <Route path='/hotel-review' component={HotelReviewPage} />
              <Route path='/housekeeping-optin' component={HousekeepingOptInPage} />
              <Route path='/housekeeping-linenchange' component={HousekeepingLinenChangePage} />
              <Route path='/upload-test' component={UploadTestPage} />
              <Route path='/print-file' component={PrintFilePage} />
              <Route path='/special-offer/:id' component={SpecialOfferClientPage} />
              <Route path='/retail-offer/:id' component={RetailOfferClientPage} />
              <Route path='/home-select-service' component={HomeSelectService} />
              <Route path='/event-facility-all' component={HomeEventAndFacilityAll} />
              <Route path='/event/:id' component={HotelEventDetailPage} />
              <Route path='/compendium/:id' component={CompendiumDetailPage} />
              <Route path='/facility/:id' component={HotelFacilityDetailPage} />
              <Route path='/guestguidedocument' component={GuestGuideDocumentPage} />
              <Route path='/PaySuccess' component={OrderPayResult} />

              <Route path='/admin/login/:token?/:language?' component={AdminLoginPage} />
              <PrivateRoute path='/admin/dashboard' component={AdminDashboardPage} />
              <PrivateRoute path='/admin/chat-intent' component={ChatIntentPage} />
              <PrivateRoute path='/admin/chat-intent-import' component={ImportChatIntentPage} />
              {/* <PrivateRoute path='/admin/item' component={AdminItemPage} /> */}
              <PrivateRoute path='/admin/outofstock' component={OutOfStockPage} />
              <PrivateRoute path='/admin/booking' component={BookingPage} />
              <PrivateRoute path='/admin/recommendation' component={OrderSetupPage} />
              <PrivateRoute path='/admin/guidedocument' component={GuideDocumentPage} />
              <PrivateRoute path='/admin/hotelfacility' component={HotelFacilityPage} />
              <PrivateRoute path='/admin/eventhotel' component={EventHotelPage} />
              <PrivateRoute path='/admin/compendium' component={SidebarPage} />
              <PrivateRoute path='/admin/fnboffer' component={SpecialOfferPage} />
              <PrivateRoute path='/admin/retailoffer' component={RetailOfferPage} />
              <PrivateRoute path='/admin/hoteldescription' component={AdminHotelDescriptionPage} />
              <PrivateRoute path='/admin/fnb-additional-item' component={FnbAdditionalItemPage} />
              <PrivateRoute path='/admin/generalsetting' component={GeneralSettingPage} />
              <PrivateRoute path='/admin/import-items' component={ImportItemLanguagePage} />
              <PrivateRoute path='/admin/cms-language' component={CmsLanguage} />
              <PrivateRoute path='/admin/cms-menu' component={CmsMenu} />
              <PrivateRoute path='/admin/item' component={CmsTask} />
              <PrivateRoute path='/admin/web-setting' component={WebSetting} />
              <PrivateRoute path='/admin/cms-transportation-type' component={CmsTransportationType} />
              <PrivateRoute path='/admin/booking-item' component={BookingItemPage} />
              <PrivateRoute path='/admin/booking-sub-category' component={BookingSubCategoryPage} />
              <PrivateRoute path='/admin/booking-category' component={BookingCategoryPage} />
              <PrivateRoute path='/admin/booking-transaction' component={BookingTransactionPage} />
              <PrivateRoute path='/admin/audit-log' component={AuditLogPage} />
              <PrivateRoute path='/admin/popup' component={PopupPage} />
              <PrivateRoute path='/admin/template' component={TemplatePage} />
              <PrivateRoute path='/admin/laundry-delivery' component={CmsLaundryDelivery} />
              <PrivateRoute path='/admin/laundry-service' component={CmsLaundryService} />
              <PrivateRoute path='/admin/outofstockrecipient' component={OutOfStockRecipientPage} />
              <PrivateRoute path='/admin/cms-payment-type' component={CmsPaymentType} />
              <PrivateRoute path='/admin/guest-login-log' component={GuestLoginLogPage} />
              <PrivateRoute path='/admin/payment-history' component={PaymentLogPage} />

              <GuestRoute path='/' component={MasterHomePage} />
            </Switch>
          </div>
        </Suspense>
      </ThemeProvider>
    )
  }
}

export default App;
